import SectionHeading from "@/components/base/SectionHeading";
import VerdictBadge from "@/components/base/VerdictBadge";
import { hotRanking, latestFeed } from "@/mocks/home";

export default function HotBoard() {
  return (
    <section id="ranking" className="relative w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="HOT BOARD"
        title="实时热度榜 × 最新疑点讨论"
        desc="按讨论量与复核进度实时排序，右侧同步滚动的疑点短讯都还在开放讨论，点进去就能加入对照。"
        actionLabel="查看完整榜单"
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-lg bg-background-50 border border-background-200 overflow-hidden">
          <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
            <h3 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
              <i className="ri-trophy-line text-accent-600"></i>
              本周鉴定热度榜
            </h3>
            <span className="font-label text-xs text-foreground-500">每小时更新</span>
          </div>

          <ul>
            {hotRanking.map((item) => {
              const top3 = item.rank <= 3;
              return (
                <li key={item.rank}>
                  <a
                    href="#cases"
                    className="flex items-start gap-4 px-5 py-4 border-b border-background-100 last:border-0 hover:bg-background-100/70 transition-colors cursor-pointer"
                  >
                    <span
                      className={`shrink-0 w-9 h-9 rounded-md flex items-center justify-center font-heading font-black text-sm ${
                        top3
                          ? "bg-accent-500 text-foreground-950"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="text-sm md:text-base text-foreground-900 leading-snug">
                        {item.title}
                      </div>
                      <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-2.5">
                        <span className="font-label text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-900">
                          {item.tag}
                        </span>
                        <span className="flex items-center gap-1 text-xs text-foreground-500">
                          <i className="ri-fire-line text-primary-500"></i>
                          热度 {item.heat}
                        </span>
                      </div>
                    </div>
                    <VerdictBadge verdict={item.verdict} type={item.verdictType} />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        <div id="discuss" className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
          <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
            <h3 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
              <i className="ri-chat-3-line text-primary-500"></i>
              最新疑点讨论
            </h3>
            <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时
            </span>
          </div>

          <ul className="divide-y divide-background-100">
            {latestFeed.map((item, idx) => (
              <li key={`${item.title}-${idx}`}>
                <a
                  href="#top"
                  className="block px-5 py-4 hover:bg-background-100/70 transition-colors cursor-pointer"
                >
                  <p className="text-sm text-foreground-900 leading-snug line-clamp-2">
                    {item.title}
                  </p>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5 mt-2.5">
                    <span className="font-label text-xs px-2 py-0.5 rounded bg-accent-100 text-accent-900">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.author}</span>
                    <span className="text-xs text-foreground-500">
                      {item.time} · {item.replies} 回复
                    </span>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}